<template>
  <button @click="onClick"
          :class="{
            'pp-ui-button': applyStyles,
            'pp-ui-hidden': !chromecast.canCast,
            'pp-ui-no-interaction': chromecast.startCasting || chromecast.stopCasting,
          }"
  >
    <slot>
      <CastConnected v-if="chromecast.isCasting"/>
      <Cast v-else-if="chromecast.canCast"/>
    </slot>
  </button>
</template>

<script>
  import { PPComponentMixin } from '../mixins'
  import Cast from '../style/assets/cast.svg'
  import CastConnected from '../style/assets/cast-connected.svg'

  export default {
    name: "PPButtonCast",
    components: { Cast, CastConnected },
    mixins: [PPComponentMixin],
    methods: {
      onClick() {
        if (this.chromecast.isCasting) {
          this.chromecast.stopCasting = true;
        } else if (this.chromecast.canCast) {
          this.chromecast.startCasting = true;
        }
      }
    }
  }
</script>
